<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 09:48:56
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:03:33
 * @name: 填写手机号
 * @Description: 填写手机号
 * @FilePath: \preSaleNafterSaleBackstage\src\components\register\set-telephone.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="registerSetTelephone">
    <div class="content">
      <div class="line">
        <font class="label">手机号码</font>
        <el-input
          class="input"
          @input="telephoneInput"
          :value="register.telephone"
          placeholder="请在此输入手机号"
          clearable
        ></el-input>
        <el-button
          type="primary"
          class="sendVerificationCode"
          size="mini"
          @click="sendVerificationCode"
          :disabled="countdown > 0"
        >
          {{ countdown === 0 ? "发送验证码" : countdown + "s" }}
        </el-button>
      </div>
      <div class="line">
        <font class="label">验证码</font>
        <el-input
          class="input"
          @input="verificationCodeInput"
          :value="register.verificationCode"
          placeholder="请在此输入验证码"
          clearable
        ></el-input>
      </div>
      <el-button class="next" type="primary" @click="next()">下一步</el-button>
    </div>
  </div>
</template>
<script>
import sms from "@/object/sms/sms.class.js";
import { debounceation } from '@/utils/decorator';

export default {
  name: "registerSetTelephone",
  props: {
    step: {
      type: Number,
      default: 1,
    },
    register: {
      type: Object,
    },
  },
  data() {
    return {
      sms: new sms(),
      countdown: 0, //验证码倒计时
      interval: "", //定时器
    };
  },
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 销毁组件时清除定时器
   */
  destroyed() {
    clearInterval(this.interval);
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入手机号
     * @param {String} e 手机号
     */
    telephoneInput(e) {
      this.register.telephone = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入验证码
     * @param {String} e 验证码
     */
    verificationCodeInput(e) {
      this.register.verificationCode = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 重置
     */
    init() {
      this.register.telephone = "";
      this.register.verificationCode = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击获取验证码
     */
    @debounceation(300)
    sendVerificationCode() {
      this.sms.sendVerificationCode().then((res) => {
        this.countdown = this.sms.countdown; //重置验证码倒计时为sms对象实例短信有效期参数
        this.interval = setInterval(() => {
          if (this.countdown === 0) {
            clearInterval(this.interval);
          } else {
            this.countdown--;
          }
        }, 1000);
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击下一步
     */
    @debounceation(300)
    next() {
      this.$emit("update:step", 2);
    },
  },
};
</script>
<style lang="scss" scoped>
.registerSetTelephone {
  width: 100%;
  @extend .extend-flex-center;
  .content {
    @extend .extend-flex-column-normal;
    .line {
      margin-bottom: 30px;
      @extend .extend-flex-start;
      .label {
        width: 80px;
        font-size: $Vars-font-miniTitle-size;
        flex-shrink: 0;
      }
      .input {
        width: 240px;
        flex-shrink: 0;
        margin-right: 30px;
      }
      .sendVerificationCode {
        width: 100px;
      }
    }
    .next {
      width: 120px;
      align-self: center;
    }
  }
}
</style>